import { SectionPosition } from '@diritto/common/home/constants/section-constants';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { RelayApi } from 'api/ApiHelper';
import { AxiosRequestConfig } from 'axios';
import { relayQueryKey } from 'queries/relay/queryKey';

export const useGetSectionsPersonalQuery = (includeAdult: boolean, position: SectionPosition, enabled = false) =>
  useQuery({
    queryKey: relayQueryKey.sectionsPersonal(includeAdult, position),
    queryFn: () => RelayApi.sectionsPersonal(includeAdult, position),
    enabled,
  });

export const prefetchHomeSectionsPersonalQuery = (
  queryClient: QueryClient,
  includeAdult: boolean,
  position: SectionPosition,
  options: AxiosRequestConfig,
) =>
  queryClient.prefetchQuery({
    queryKey: relayQueryKey.sectionsPersonal(includeAdult, position),
    queryFn: () => RelayApi.sectionsPersonal(includeAdult, position, options),
  });

export const fetchHomeSectionsPersonalQuery = (
  queryClient: QueryClient,
  includeAdult: boolean,
  position: SectionPosition,
  options: AxiosRequestConfig,
) =>
  queryClient.fetchQuery({
    queryKey: relayQueryKey.sectionsPersonal(includeAdult, position),
    queryFn: () => RelayApi.sectionsPersonal(includeAdult, position, options),
  });
